var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.current.components.content),function(item,index){return [_c('important2',{key:item.system_id+'_'+index,tag:"div",attrs:{"dataAll":{current:item}}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }